// extracted by mini-css-extract-plugin
export default {"root":"IconFishmonger_root__7tUDK"};